import { RootState } from "../../store";
import { TreeItems } from "../../../components/navigation/components/sortable-tree/utils/types";

export const navigationResourceExplorerDataSelector = (
  state: RootState,
): TreeItems | null => {
  return state.navigation?.resourceExplorer;
};
